import { ChangeDetectionStrategy, Component } from "@angular/core";

import { IIconComponent } from "@front/m19-ui";

@Component({
  selector: "app-drag-icon",
  imports: [IIconComponent],
  template: ` <IIcon name="dragVertical" class="flex text-gray-400" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DragIconComponent {}
